export default "__VITE_ASSET__BCgVGdGh__"